module.exports = __webpack_public_path__ + "static/media/img_3.84f4efc2.png";